import { useDemandStudioContext } from "../../contexts/DemandStudioContext";
import XButton from "../common/XButton";

const wrapClasses =
  "inline-flex items-center gap-2 py-1.5 px-2.5 " +
  "border border-border rounded-full bg-white";

const inputClasses =
  "w-70 border-0 outline-none text-sm leading-5 " +
  "text-content bg-transparent placeholder:text-subtle";

const counterClasses = "min-w-[calc(var(--spacing)*10.5)] text-xs font-semibold text-subtle text-center";

const navBtnClasses =
  "w-7 h-7 inline-flex items-center justify-center " +
  "border border-border rounded-full bg-white text-subtle cursor-pointer " +
  "hover:not-disabled:border-primary hover:not-disabled:text-primary " +
  "disabled:opacity-50 disabled:cursor-not-allowed";

const clearBtnClasses =
  "border-0 bg-transparent text-[calc(var(--spacing)*3.25)] font-semibold " +
  "text-primary cursor-pointer hover:text-primary-hover";

const DemandStudioSearchBar = () => {
  const {
    searchTerm,
    onSearchChange,
    onSearchKeyDown,
    matchCount,
    activeMatchNumber,
    goToPreviousMatch,
    goToNextMatch,
    hasSearch,
    clearSearch,
  } = useDemandStudioContext();

  return (
    <div className={wrapClasses}>
      <input
        type="text"
        value={searchTerm}
        onChange={(event) => onSearchChange(event.target.value)}
        onKeyDown={onSearchKeyDown}
        className={inputClasses}
        placeholder="Search section text"
        aria-label="Search revisions"
      />
      <span className={counterClasses}>
        {matchCount ? `${activeMatchNumber}/${matchCount}` : "0/0"}
      </span>
      <XButton
        variant="close"
        className={navBtnClasses}
        onClick={goToPreviousMatch}
        disabled={!matchCount}
        aria-label="Previous search result"
      >
        <i className="fa fa-chevron-up" />
      </XButton>
      <XButton
        variant="close"
        className={navBtnClasses}
        onClick={goToNextMatch}
        disabled={!matchCount}
        aria-label="Next search result"
      >
        <i className="fa fa-chevron-down" />
      </XButton>
      {hasSearch && (
        <XButton
          variant="close"
          className={clearBtnClasses}
          onClick={clearSearch}
          aria-label="Clear search"
        >
          Clear
        </XButton>
      )}
    </div>
  );
};

export default DemandStudioSearchBar;
